import React, { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import { http } from "@/lib/api";
import { VideoCard } from "@/components/VideoCard";
import { YT } from "@/constants/testIds";

export default function Search() {
  const [params] = useSearchParams();
  const q = params.get("q") || "";
  const [videos, setVideos] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    let alive = true;
    if (!q) {
      setVideos([]);
      return;
    }
    setLoading(true);
    http
      .get(`/videos`, { params: { q } })
      .then((r) => {
        if (!alive) return;
        setVideos(r.data || []);
      })
      .finally(() => alive && setLoading(false));
    return () => {
      alive = false;
    };
  }, [q]);

  return (
    <div data-testid={YT.searchPage}>
      <div className="yt-section">
        <div className="yt-section-title">
          Search results for <em>"{q}"</em>
          <span
            style={{ marginLeft: 8, fontWeight: "normal", color: "#666" }}
            data-testid={YT.searchResultCount}
          >
            ({videos.length} videos)
          </span>
        </div>
        <div className="yt-section-body">
          {loading ? (
            <div style={{ padding: 12, color: "#555" }}>Searching…</div>
          ) : videos.length === 0 ? (
            <div style={{ padding: 12, color: "#555" }}>
              No videos matched your search.
            </div>
          ) : (
            <div className="yt-grid">
              {videos.map((v) => (
                <VideoCard key={v.video_id} video={v} />
              ))}
            </div>
          )}
        </div>
      </div>
    </div>
  );
}
